module.exports = "/legacy/1923b81be8fd2e67fdc0ef88f257feaf.svg";